/*
  Геометрия знака Kaname — из утверждённого финального SVG (graphical/kaname-final). Один лепесток,
  заданный относительно оси веера; шесть копий повёрнуты на 60°. Лепесток с поворотом 0 стоит на
  6 часах, положительный поворот идёт по часовой стрелке. Ядро — круг на оси.
*/

export const PETAL_D =
  'M -129.46 49.15 Q -109.96 31.65 -107.46 32.15 Q -104.96 32.65 -101.96 57.65 Q -98.96 82.65 -91.46 108.65 Q -83.96 134.65 -64.46 176.65 Q -44.96 218.65 -32.96 238.15 Q -20.96 257.65 -2.46 282.15 Q 16.04 306.65 34.04 325.65 Q 52.04 344.65 70.04 360.15 Q 88.04 375.65 89.04 420.15 Q 90.04 464.65 89.54 469.65 Q 89.04 474.65 86.04 478.15 Q 83.04 481.65 74.04 481.65 Q 65.04 481.65 26.04 473.65 Q -12.96 465.65 -58.96 451.65 Q -104.96 437.65 -147.46 417.15 Q -189.96 396.65 -202.46 387.65 Q -214.96 378.65 -222.96 367.65 Q -230.96 356.65 -234.46 338.15 Q -237.96 319.65 -237.46 294.15 Q -236.96 268.65 -232.96 244.15 Q -228.96 219.65 -222.46 197.65 Q -215.96 175.65 -206.96 155.65 Q -197.96 135.65 -183.96 113.65 Q -169.96 91.65 -159.46 79.15 Q -148.96 66.65 -129.46 49.15 Z';

/** Половина стороны квадрата, в который вписан знак, в единицах лепестка. */
export const MARK_HALF = 485;

/** Радиус ядра. */
export const CORE_R = 74;

export const PETALS = [0, 1, 2, 3, 4, 5] as const;

/** Лист листопада — небольшая капля (за окнами знака и на земле сцены входа). */
export const LEAF_D = 'M0 -13 C 8 -8 9 5 0 13 C -9 5 -8 -8 0 -13 Z';

/**
 * Иероглиф 要 (канамэ — ось складного веера; главное, то, что держит целое): контур из Noto Sans JP 400,
 * em 1000, ось y вверх. Рисуется svg с viewBox «0 -880 1000 1000» и отражением по y — так не нужно грузить
 * японский шрифт ради одного знака.
 */
export const KANAME_KANJI_D =
  'M46 294H324Q358 343 385 386H119V645H342V730H69V797H930V730H647V645H888V386H439L466 379Q440 338 411 294H955V231H756Q725 161 675 110Q654 89 630 71Q687 56 741 41Q848 9 925 -21L879 -82Q803 -51 700 -19Q630 3 553 23Q543 18 534 14Q451 -24 340 -46Q229 -69 89 -79Q86 -63 78 -44Q69 -26 59 -13Q238 -3 365 27Q407 36 445 50Q357 71 265 88Q254 74 244 61L173 86Q206 127 245 181Q263 206 281 231H46ZM306 143Q409 124 511 101Q525 97 539 94Q556 104 572 115Q635 161 673 231H368Q342 193 316 157Q311 150 306 143ZM647 583V447H814V583ZM576 447V583H413V447ZM190 583V447H342V583ZM413 645H576V730H413Z';
